import { render, staticRenderFns } from "./footer-top.vue?vue&type=template&id=0b507c26&"
import script from "./footer-top.vue?vue&type=script&lang=js&"
export * from "./footer-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports